import HistoryIcon from "@/src/assets/icons/ic_history.svg?react"

import Box from "@mui/material/Box"

import { paths } from "src/routes/paths"

import { CONFIG } from "src/config-global"

import { SvgColor } from "src/common/svg-color"

import { Iconify } from "../../common/iconify"

import BriefcaseIcon from "@/src/assets/icons/briefcase.svg?react"
import DealIcon from "@/src/assets/icons/deal.svg?react"

// ----------------------------------------------------------------------

const icon = (name: string, props?: any) => (
    <SvgColor src={`${CONFIG.site.basePath}/assets/icons/navbar/${name}.svg`} {...props} />
)

const ICONS = {
    briefcase: <BriefcaseIcon />,
    deal: <DealIcon style={{ width: "45px !important", height: "45px !important" }} />,
    history: <HistoryIcon style={{ width: "20px", height: "20px" }} />,
    userManagement: icon("ic-user-management"),
}

// ----------------------------------------------------------------------

export const navData = [
    {
        subheader: "",
        items: [
            { title: "Jobs", path: paths.dashboard.root, icon: ICONS.briefcase },
            { title: "Clients", path: paths.dashboard.clients, icon: ICONS.deal, permissions: ["viewClients"] },
            // Temporarily hidden - will be brought back later
            // {
            //     title: "History",
            //     path: paths.dashboard.bulkUpload,
            //     icon: ICONS.history,
            //     permissions: ["viewBulkJobs"],
            // },
            // Temporarily hidden - will be brought back later
            // {
            //     title: "User Management",
            //     path: paths.dashboard.userManagement,
            //     icon: ICONS.userManagement,
            //     permissions: ["viewUserManagementPage"],
            // },
            {
                title: "Credits",
                path: paths.dashboard.credits.root,
                icon: <Iconify icon="material-symbols:credit-card" width="24" height="24" />,
                permissions: ["viewBilling"],
            },
            {
                title: "Question Bank",
                path: paths.dashboard.questionBank,
                icon: <Iconify icon="solar:library-bold" width="24" height="24" />,
                permissions: ["createJob"],
            },
        ],
    },
]
